export default __webpack_public_path__ + "static/chinaHeader-2ebce88d0f9e789c3ac43f656ad80e2f.jpg";